import { render, staticRenderFns } from "./WIPPattern.vue?vue&type=template&id=4c807b63&scoped=true&"
import script from "./WIPPattern.vue?vue&type=script&lang=js&"
export * from "./WIPPattern.vue?vue&type=script&lang=js&"
import style0 from "./WIPPattern.vue?vue&type=style&index=0&id=4c807b63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c807b63",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QSelect,QBtn,QMarkupTable,QPagination} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QToolbarTitle,QCard,QCardSection,QSpace,QSelect,QBtn,QMarkupTable,QPagination}, component.options.components || {})
